import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import AppContext from './context/app-context';
import './index.css';

const rootElement = document.getElementById('sns-root') as HTMLElement;

// @ts-ignore
const bannerInContext = document.getElementById('banner').dataset.banner;
// @ts-ignore
const environmentInContext = document.getElementById('env').dataset.env;
// @ts-ignore
const isBusinessBanner = document.getElementById('isBusinessBanner').dataset.isbusinessbanner;

const appData = {
  banner: bannerInContext,
  env: environmentInContext,
  isBusinessBanner: isBusinessBanner === 'true',
  platform: 'web',
  applicationName: 'Schedule and Save',
};

const root = createRoot(rootElement);

root.render(
  <AppContext appData={appData}>
    <App />
  </AppContext>,
);
